<template>
  <div class="story-list">
    <HomeList :getListApi="getbusinesses" :params="homeListParams">
      <template>
        <StoryItem
          v-for="(item, index) in storyList"
          :key="index"
          :storyInfo="item"
          @goDes="goDes"
          @goTagDes="goTagDes"
        ></StoryItem>
      </template>
    </HomeList>
  </div>
</template>
<script>
import HomeList from 'component/platform/homepage/common/homeList.vue'
import StoryItem from 'component/platform/homepage/normalUser/storyItem.vue'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
export default {
  props: {},
  mixins: [homepageMixin],
  components: {
    HomeList,
    StoryItem
  },
  data() {
    return {
      homeListParams: {},
      isShowList: false
    }
  },
  computed: {
    storyList() {
      return this.$store.getters['homepage/getTabListData']('story') || []
    }
  },
  created() {},
  mounted() {
    // 获取token, 再发起请求
    this.mixinGetToken().then(token => {
      this.token = token
      this.homeListParams = {
        user_id: this.$route.params.userId,
        token: token,
        business_type: 'story'
      }
      this.isShowList = true
    })
  },
  methods: {
    goDes() {
      this.$trackEvent('newprofilepages_story_click', {})
    },
    goTagDes() {
      this.$trackEvent('newprofilepages_story_story', {})
    },
    getbusinesses(params) {
      return this.$store.dispatch('homepage/fetchBusinesses', params)
    }
  }
}
</script>
<style lang="scss" scoped>
.story-list {
  margin: 30px 0;
}
</style>
